import TriggerJsonModel from './trigger/TriggerJsonModel';
import TrackerVariable from './variable/TrackerVariable';
import TrackerEventMappingJsonModel from './TrackerEventMappingJsonModel';
import { AccessBase } from '../access/BaseAccess';
import { DeploymentStatus } from '../../constant/Constants';

interface Tracker extends AccessBase {
  name: string;
  description: string;
  platform: EventTrackerPlatform;
  triggers: Array<TriggerJsonModel>;
  variables: Array<TrackerVariable>;
  event: TrackerEventMappingJsonModel;
  stage: DeploymentStatus;
}

export enum EventTrackerPlatform {
  WEB = 'WEB',
  MOBILE = 'MOBILE',
}

export default Tracker;
